import { SMSMessageDto } from 'data/dtos/SMSMessageDto';
import { DirectMessageModel } from 'data/models/DirectMessageModel';
import { WorkawareApi } from '../../apis/WorkawareApi'
import { DirectMessageLogEntryDto } from '../../data/dtos/DirectMessageLogEntryDto';
import { PagedResult } from "../../types/apis"
export class directMessageServie {
   private _api: WorkawareApi
    constructor(api:WorkawareApi){
        this._api = api
    }

   get = (page: number, rowsPerPage: number) =>
  new Promise<PagedResult<DirectMessageLogEntryDto>>((resolve, reject) => {
    this._api.directMessage
      .getLog(page, rowsPerPage)
      .then((result) => {
        const values = (result.Values as DirectMessageLogEntryDto[])
          .slice() // avoid mutating original
          .sort((a, b) => new Date(b.CreatedOn).getTime() - new Date(a.CreatedOn).getTime());

        resolve({
          Count: result["Count"] as number,
          Values: values,
        });
      })
      .catch((error) => reject(error));
  });

    addMessage=(data:DirectMessageModel) => new Promise<DirectMessageModel>((resolve,reject) =>{
        this._api.directMessage.post(data)
        .then(result => resolve(result))
        .catch(error => reject(error))
    })
    sendMessage=(data:SMSMessageDto) => new Promise<SMSMessageDto>((resolve,reject) =>{
        this._api.directMessage.smsPost(data)
        .then(result => resolve(result))
        .catch(error => reject(error))
    })
      deleteMessage = (id: number) => this._api.directMessage.remove(id);
}